export const DEFAULT_CLUSTER_TYPE = 'Engagement'
export const DEFAULT_CLUSTER_TOOLTIP_KEY = 'CreatorClusterEngagement'
